module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "pv"
    }
  }), _vm._v(" "), _c('b', [_vm._v("This book is dedicated to an American Icon, the proud")]), _vm._v(" "), _c('b', [_vm._v("Company that builds them, the thousands of people")]), _vm._v(" "), _c('b', [_vm._v("who compose that Company, the founding four men")]), _vm._v(" "), _c('b', [_vm._v("who started it all, their families who carried the")]), _vm._v(" "), _c('b', [_vm._v("dream through good times and bad, and to you the")]), _vm._v(" "), _c('b', [_vm._v("American people who have made Harley-Davidson")]), _vm._v(" "), _c('b', [_vm._v("a symbol of America and freedom.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133e2d69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front02.vue
// module id = 63
// module chunks = 0